<template>
  <v-col cols="12" md="3" sm="12">
    <v-card :loading="loading" class="mx-auto dashboard-card" height="200" elevation="4">
      <v-card-text class="card-header">
        <v-icon class="mr-2" color="primary">fa fa-universal-access</v-icon>
        <span class="text-h6 font-weight-medium">Matrículas AEE</span>
      </v-card-text>

      <v-row class="card-content" align="center" no-gutters>
        <v-col cols="7" class="pl-4">
          <v-card-text class="text-h3 font-weight-bold primary--text">
            {{ qtd ?? 0 }}
          </v-card-text>
          <v-card-text class="text-caption grey--text"> Total atual </v-card-text>
        </v-col>

        <v-col cols="5" class="chart-container">
          <apexchart type="area" height="150" :options="chartOptions" :series="series"></apexchart>
        </v-col>
      </v-row>
    </v-card>
  </v-col>
</template>

<script>
export default {
  props: {
    franquiaId: {
      type: Number,
    },
  },
  name: "MatriculasAeePorUnidade",
  mounted() {
    this.getQtd(this.franquiaId);
  },
  watch: {
    franquiaId(value) {
      this.loading = true;
      this.getQtd(value);
      this.loading = false;
    },
  },
  data() {
    return {
      qtd: 0,
      loading: true,
      series: [
        {
          name: "Matriculas AEE",
          data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        },
      ],
      chartOptions: {
        chart: {
          height: 150,
          type: "area",
          toolbar: {
            show: false,
          },
          zoom: {
            enabled: false,
          },
        },
        colors: ["#4CAF50"],
        stroke: {
          curve: "smooth",
          width: 2,
        },
        fill: {
          type: "gradient",
          gradient: {
            shadeIntensity: 0.5,
            opacityFrom: 0.4,
            opacityTo: 0.2,
          },
        },
        dataLabels: {
          enabled: false,
        },
        markers: {
          size: 3,
          hover: {
            size: 5,
          },
        },
        grid: {
          show: false,
          padding: {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
          },
        },
        yaxis: {
          show: true,
          labels: {
            show: true,
            style: {
              fontSize: "10px",
            },
          },
        },
        xaxis: {
          labels: {
            show: true,
            style: {
              fontSize: "10px",
            },
          },
          categories: [
            "Jan",
            "Fev",
            "Mar",
            "Abr",
            "Mai",
            "Jun",
            "Jul",
            "Ago",
            "Set",
            "Out",
            "Nov",
            "Dez",
          ],
        },
      },
    };
  },
  methods: {
    async getQtd(franquia) {
      const response = await this.$services.matriculasService.qtdAeePorFranquia(franquia);
      this.qtd = response.qtd;

      const data = response.metricasPorMes.map((q) => q.qtd);
      this.series = [
        {
          name: "Matriculas AEE",
          data: [...data],
        },
      ];

      this.loading = false;
    },
  },
};
</script>

<style scoped>
.dashboard-card {
  border-radius: 12px;
  overflow: hidden;
  transition: all 0.3s ease;
  border-top: 4px solid #fbbb14;
}

.dashboard-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1) !important;
}

.card-header {
  padding-bottom: 0;
  display: flex;
  align-items: center;
  background-color: #f8f9fa;
  border-bottom: 1px solid #eee;
}

.card-content {
  height: calc(100% - 48px);
}

.chart-container {
  padding-right: 8px;
  height: 100%;
  display: flex;
  align-items: center;
}

.text-h3 {
  line-height: 1.2;
}

.primary--text {
  color: #1976d2 !important;
}
</style>
